import { ArrowRight } from "@phosphor-icons/react";
import { useEDCFlow } from "@smvtech/x-flux";

type Props = {
	onNext: () => void;
};

const Homescreen = ({ onNext }: Props) => {
	const { order } = useEDCFlow();

	return (
		<div className="h-dvh overflow-hidden bg-white flex flex-col">
			<div className="py-[13px] border-b border-gray-200 text-center shrink-0">
				<p className="text-sm font-semibold text-[#3730A3]">{order?.organisation?.name}</p>
			</div>
			<div className="flex-1 flex items-center justify-center px-6 min-h-0">
				<div className="w-full max-w-sm flex flex-col items-center text-center">
					<img
						src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/biz-share-questionnaire/homescreen_hero.png"
						alt="Visa start"
						className="w-full max-h-[40vh] object-contain"
					/>

					<div className="mb-7">
						<p className="text-base font-semibold text-black mb-2">
							Your travel agent at {order?.organisation?.name} needs a few details to process your visa
						</p>

						<p className="text-sm font-medium text-[#909090]">This usually takes 3–5 minutes.</p>
					</div>

					<button
						onClick={onNext}
						className="w-full h-11 rounded-lg border border-[#4E45C4]
               bg-gradient-to-b from-[#554FB0] to-[#332D96]
               text-white text-base font-medium
               flex items-center justify-center gap-2
               mb-3  /* 12px gap to bottom text */
               active:scale-[0.98] transition">
						Get Started <ArrowRight size={16} />
					</button>

					<p className="text-xs font-normal">Your details are shared securely.</p>
				</div>
			</div>
		</div>
	);
};

export default Homescreen;

